import { Box } from "@mui/material";
import FavoriteList from "../components/favorite/favoriteList/FavoriteList";

const Favorite = () => {
  return (
    <Box>
      <FavoriteList />
    </Box>
  );
};
export default Favorite;
